<template>
	<div id="contentItem"
		 v-on:mouseover="showOverlay=true"
		 v-on:mouseout="showOverlay=false"
		 v-bind:draggable="isDraggable ? true : false"
		 @dragstart="dragStart(slide.id, $event)"
		 @dragend="dragStop()">

		<div class="thumbnail">
			<img v-if="isImage === true" v-bind:src="getImage"/>
			<video v-else v-bind:src="getVideo"/>
			<div class="filename">{{this.slide.title}}</div>
		</div>
		<div class="overlay" v-show="showOverlay && isEditable">
			<IconBase class="icon" iconName="editieren" width="36" height="36"
					  @onIconClicked="editSlide">
				<IconEdit/>
			</IconBase>
			<IconBase class="icon" iconName="löschen" width="36" height="36"
					  @onIconClicked="showDeleteDialog = true">
				<IconDelete/>
			</IconBase>
		</div>

		<div class="deleteDialog" v-show="showDeleteDialog">
			<div class="deleteText">
				<p>Wollen Sie die Datei wirklich löschen?</p>
			</div>
			<div class="buttonGroup">
				<button class="button" v-on:click.stop.prevent="deleteSlide">
					Ja
				</button>
				<button class="button"
						v-on:click.stop.prevent="showDeleteDialog = false">Nein
				</button>
			</div>
		</div>

	</div>
</template>

<script>
	import {EventBus} from '@/services/EventBus.js';
	import IconBase from '@/components/icons/IconBase.vue';
	import IconDelete from '@/components/icons/IconDelete.vue';
	import IconEdit from '@/components/icons/IconEdit.vue';

	export default {
		name: "ContentItem",
		components: {
			IconBase,
			IconEdit,
			IconDelete
		},
		props: [
			"slide",
			"isEditable",
			"isDraggable",
			"type"
		],
		data() {
			return {
				showOverlay: false,
				showDeleteDialog: false,
				isImage: true
			}
		},
		methods: {
			deleteSlide() {
				//console.log("delete this slidewith id="+this.slide.id);
				this.showOverlay = false;
				EventBus.$emit('onDeleteSlide', this.slide);
			},
			editSlide() {
				//console.log("edit this slide: "+this.slide.id);
				EventBus.$emit('onEditSlide', this.slide);
				this.showOverlay = false;
			},
			dragStart(slideId, event) {
				if (!this.isDraggable) {
					event.preventDefault();
				}


				if (this.type === 'wall') {
					document.querySelector('.model-disable').classList.add('show-diable');
				} else {
					document.querySelector('.wall-disable').classList.add('show-diable');
				}

				let itemList = document.querySelectorAll('.item:not(.' + this.type + ')');
				for (let i = 0; i < itemList.length; ++i) {
					itemList[i].classList.add('drop-disable');
				}

				itemList = document.querySelectorAll('.item.' + this.type);
				for (let i = 0; i < itemList.length; ++i) {
					itemList[i].classList.add('drop-enabled');
				}

				let slideInfo = {id: slideId, type: this.type};
				event.dataTransfer.setData('slide_info', JSON.stringify(slideInfo));
				event.dataTransfer.dropEffect = 'move';
			},
			dragStop() {
				let itemList = document.querySelectorAll('.item');

				for (let i = 0; i < itemList.length; ++i) {
					itemList[i].classList.remove('drop-disable');
					itemList[i].classList.remove('drop-enabled');
					itemList[i].classList.remove('drag-right');
				}

				document.querySelector('.wall-disable').classList.remove('show-diable');
				document.querySelector('.model-disable').classList.remove('show-diable');

			}
		},
		computed: {
			getFileName() {
				return (this.slide.media.name + this.slide.media.ext);
			},
			getImage() {
				if(this.slide.media.formats && this.slide.media.formats.thumbnail) {
					return (process.env.VUE_APP_BASE_URL + this.slide.media.formats.thumbnail.url);
            	} else {
					return (process.env.VUE_APP_BASE_URL + this.slide.media.url);
				}
			},
			getVideo() {
				return (process.env.VUE_APP_BASE_URL + this.slide.media.url + '#t=5');
			}
		},
		created() {
			this.showOverlay = false;
			this.showDeleteDialog = false;
			if(this.slide.media.mime.includes('video')) {
				this.isImage = false;
			}
		}
	}
</script>

<style scoped>
	#contentItem {
		font-family: "BrownLLWeb-Regular";
		color: black;
		width: 233px;
		margin: 25px 0px 0px 25px;
		position: relative;
	}

	img,
	video {
		height: 128px;
		width: 233px;
		object-fit: contain;
		border: solid 1px black;
	}

	.thumbnail {
		transition: all ease 0.25s;
	}

	.filename {
		padding-top: 2px;
		font-size: 12px;
	}

	.overlay {
		cursor: default;
		background: rgba(0, 0, 0, 0.5);
		color: white;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 128px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.icon {
		margin: 15px;
	}

	.button {
		font-size: 15px;
		margin: 10px 10px 5px 10px;
	}

	.deleteDialog {
		height: 128px;
		padding-top: 10px;
	}

	.deleteText {
		font-size: 18px;
	}

</style>